/* unplugin-vue-components disabled */import { render } from "./Unfolding3DView.vue?vue&type=template&id=6131b478&scoped=true"
import script from "./Unfolding3DView.vue?vue&type=script&lang=js"
export * from "./Unfolding3DView.vue?vue&type=script&lang=js"

import "./Unfolding3DView.vue?vue&type=style&index=0&id=6131b478&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6131b478"]])

export default __exports__